import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import homeImg from '../../assets/img/hero-img.png';
import './hero.css';

const Hero = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true,     // Animation happens only once
    });
  }, []);

  return (
    <section id="home" className="hero home section dark-background">
      <div className="container">
        <div className="row gy-4">
          {/* Left Text Section */}
          <div
            className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"
            data-aos="fade-in"
          >
            <h1>No.1 Website Development Company in India</h1>
            <p>We are a team of talented designers crafting exceptional websites.</p>
            <div className="d-flex">
              <a href="#about" className="btn-get-started">Get Started</a>
            </div>
          </div>
          {/* Right Image Section */}
          <div
            className="col-lg-6 order-1 order-lg-2 hero-img"
            data-aos="zoom-out"
            data-aos-delay="100"
          >
            <img src="assets/img/hero-img.png"className="img-fluid animated" alt="Hero" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
